import { useTranslation } from 'react-i18next'

export default function Spinner({ label }) {
  const { t } = useTranslation('common')
  const text = label ?? t('loading')
  return (
    <div role="status" className="flex items-center justify-center gap-3 py-10 text-slate-500 dark:text-slate-400">
      <span
        aria-hidden="true"
        className="size-5 animate-spin rounded-full border-2 border-brand-500 border-t-transparent"
      />
      <span className="text-sm">{text}…</span>
    </div>
  )
}
